// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from '/vercel/path0/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import CrownOutlined from '/vercel/path0/node_modules/@ant-design/icons/es/icons/CrownOutlined';
import TableOutlined from '/vercel/path0/node_modules/@ant-design/icons/es/icons/TableOutlined';
export default { SmileOutlined, CrownOutlined, TableOutlined };
